import axios from 'axios'
const baseurl = process.env.REACT_APP_API_URL

export const getProducts = async (
  data,
  pagenum,
  productsNum,
  minPrice,
  maxPrice,
  adType,
  subCategoryId
) => {
  const res = await axios({
    method: 'post',
    url:
      baseurl +
      `/getProducts?page=${pagenum}&limit=${productsNum}&search=&minPrice=${minPrice}&maxPrice=${maxPrice}&adType=${adType}`,
    data: {
      productType: data,
      categoryId: subCategoryId
    }
  })
  if (res.status === 200) {
    return res?.data?.data
  } else {
    return false
  }
}

export const getProductDetails = async id => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/getProductDetails?productId=${id}`
  })
  return res.data.data
}

export const reportProduct = async (data, token) => {
  const res = await axios({
    method: 'post',
    url: baseurl + `/report`,
    data: data,
    headers: {
      token: token
    }
  })
}

export const topMachineProducts = async () => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/topMachineryProduct`
  })
  return res?.data?.data
}

export const topFarmlandProducts = async () => {
  const res = await axios({
    method: 'get',
    url: baseurl + `/topFarmalandProduct`
  })
  return res?.data?.data
}
